export default "__VITE_ASSET__tgwk4yQq__"